import { Card, Col, Row, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppStateContext } from "../../context/AppContext";
import useRequest from "../../hooks/useRequest";
import VideoContent from "./VideoContent";
import ImageContent from "./ImageContent ";



const { TabPane } = Tabs;

const cmsTabs = {
  VIDEOCONTENT : ("Video Content"),
  IMAGECONTENT: ("Image Content")

};

function Index() {
  const { setPageHeading } = useContext(AppStateContext);
  const [selectedTab, setSelectedTab] = useState("videoContent");
  const handleTabChange = (status) => {
    setSelectedTab(status);
  };

  useEffect(() => {
    setPageHeading(("Content Management"));
  }, []);

  return (
    <>
      <div className="tabled quoteManagement">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
            <VideoContent />
              {/* <Tabs
                className="main_tabs"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >           
                <TabPane tab={cmsTabs.VIDEOCONTENT} key={"videoContent"}>
                  <div className="cms-bodycontent">
                  <VideoContent />
                  </div>
                </TabPane>
                <TabPane tab={cmsTabs.IMAGECONTENT} key={"imageContent"}>
                  <ImageContent />
                </TabPane>
              </Tabs> */}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
